module.exports = __webpack_public_path__ + "img/emitFacefilter02.48442e71.png";